module.exports = __webpack_public_path__ + "img/ic_qmarker_generic_lbl_issue.89e67cc3.png";